import type { ReactNode } from 'react'

interface BusinessNameGeneratorContainerProps {
    eyebrow: string
    title: ReactNode
    description: ReactNode
    children: ReactNode
}

export function BusinessNameGeneratorContainer({
    eyebrow,
    title,
    description,
    children,
}: BusinessNameGeneratorContainerProps) {
    return (
        <section
            className="py-6 sm:py-10"
            aria-labelledby="generator-heading"
        >
            <div className="mx-auto mb-8 max-w-3xl text-center">
                <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-primary">
                    {eyebrow}
                </p>

                <h1
                    id="generator-heading"
                    className="mb-3 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl"
                >
                    {title}
                </h1>

                <p className="mx-auto max-w-2xl text-sm leading-relaxed text-gray-500 sm:text-base">
                    {description}
                </p>
            </div>

            {children}
        </section>
    )
}
